import {
  Box,
  BoxProps,
  Center,
  Flex,
  FlexProps,
  Heading,
  // Stack,
  Text,
  Icon,
  Button,
} from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { HiOutlineClock } from 'react-icons/hi';

import { useEventData } from '../../hooks';
import { ReactNode, useCallback, useEffect } from 'react';
import { useCartStore, useCheckoutStore } from '../../stores';

import ReactPixel from 'react-facebook-pixel';
import ReactGA4 from 'react-ga4';
import { deleteCookie, getCookie } from 'src/utils/cookie';

type ContainerProps = FlexProps & {
  children: ReactNode;
};

const Container = ({ children, ...props }: ContainerProps) => (
  <Flex
    as="section"
    direction="column"
    align="center"
    w="100%"
    maxW="sm"
    {...props}>
    {children}
  </Flex>
);

type CardProps = BoxProps & {
  children: ReactNode;
};
const Card = ({ children, ...props }: CardProps) => (
  <Box
    boxShadow="container"
    borderRadius="xl"
    bg="white"
    p="6"
    w="100%"
    {...props}>
    {children}
  </Box>
);

export const CheckoutPixSuccess = () => {
  const navigate = useNavigate();
  const handleOnNavigate = () => {
    navigate('/me/tickets');
  };

  const {
    getEventCartItemsAdded,
    getEventCartTotal,
    getEventCartTotalTickets,
    reinitializeEventCart,
  } = useCartStore();

  const event = useEventData();
  const { eventID } = useParams();
  const existingCookie = getCookie('uticketPrivateLinkName');  

  const { clearEventCheckout } = useCheckoutStore();

  const goToPage = useCallback(() => {
    navigate('/me/tickets');
  }, [navigate]);

  useEffect(() => {
    if (event) {
      const total = getEventCartTotal(event?.id);
      const cartItemsAdded = getEventCartItemsAdded(event.id);
      const totalTickets = getEventCartTotalTickets(event.id);
      const contents = {
        id: event.id,
        quantity: totalTickets,
      };

      // @ts-ignore
      window.dataLayer.push({
        price: total,
        eventName: event.name,
        items: cartItemsAdded,
        quantityTotal: totalTickets,
        quantity: cartItemsAdded.length,
      });

      if (
        event?.integrations?.pixelId &&
        window.location.href.includes(event.id)
      ) {
        ReactPixel.trackSingle(event.integrations?.pixelId, 'Purchase', {
          content_type: 'product',
          content_ids: [event.id],
          value: getEventCartTotal(event.id),
          contents: contents,
          num_items: totalTickets,
          content_name: event.name,
          currency: 'BRL',
        });
      }

      const purchaseReactGA4 = {
        item_category: 'product',
        item_list_id: event.id,
        quantity: totalTickets,
        item_name: event.name,
      };

      ReactGA4.event('purchase', {
        currency: 'BRL',
        value: getEventCartTotal(event.id),
        items: [purchaseReactGA4],
      });

      clearEventCheckout(event.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    event,
    getEventCartItemsAdded,
    getEventCartTotal,
    getEventCartTotalTickets,
  ]);

    useEffect(() => {
      if(existingCookie) {
        const timeoutId = setTimeout(() => {
          deleteCookie('uticketPrivateLinkName');
        }, 0);
  
        return () => {
          clearTimeout(timeoutId);
        };
      }
    }, [existingCookie])

  useEffect(() => {
    reinitializeEventCart(eventID!, event?.ticketTypes);
  }, [event?.ticketTypes, eventID, reinitializeEventCart]);

  useEffect(() => {
    if (!event) {
      goToPage();
    }
  }, [event, goToPage]);

  return (
    <Center
      flexDirection="column"
      position="fixed"
      top={0}
      bottom={0}
      left={0}
      right={0}
      bg="#4caf50"
      p="5">
      <Container maxW="xl">
        <Icon as={HiOutlineClock} boxSize="20" color="white" mb="2" />
        <Heading
          fontSize="4xl"
          color="white"
          textAlign="center"
          as="h1"
          m="0"
          mb="10">
          Compra efetuada!
        </Heading>
        <Card>
          <Text color="black" mb="6">
            {`Você já tem acesso aos seus ingressos para ${
              event?.name ?? ''
            }. Para vê-los, vá para 'Meus ingressos'.`}
          </Text>
          <Button
            onClick={handleOnNavigate}
            w="full"
            colorScheme="blue"
            rounded="full">
            Meus Ingressos
          </Button>
        </Card>
      </Container>
    </Center>
  );
};
